import { render, staticRenderFns } from "./LogVersionForm.vue?vue&type=template&id=dad1ed7a&"
import script from "./LogVersionForm.vue?vue&type=script&lang=js&"
export * from "./LogVersionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports